export default __webpack_public_path__ + "static/arrowmont-bfb0e68e7088e1b8e3e29a42a476c54e.png";